import { generatePath, useNavigate } from 'react-router'
import { useDispatch } from 'react-redux'
import {
  type ChildDuplicate,
  updateDuplicateInfo,
  useLazyCheckChildDuplicateQuery
} from 'slices/duplicateChildSlice'
import * as AppRoutes from 'Pages/Routes'

interface DuplicateCheckOptions {
  childIdOverride?: number
  routeId?: string | null
}

export const useDuplicateCheck = (): {
  checkAndHandleDuplicate: (dupeRecord: ChildDuplicate, options?: DuplicateCheckOptions) => Promise<boolean>
} => {
  const [triggerDupeCheck] = useLazyCheckChildDuplicateQuery()
  const dispatch = useDispatch()
  const nav = useNavigate()

  const checkAndHandleDuplicate = async (
    dupeRecord: ChildDuplicate,
    options?: DuplicateCheckOptions
  ): Promise<boolean> => {
    const checkRecord = options?.childIdOverride != null
      ? { ...dupeRecord, childId: options.childIdOverride }
      : dupeRecord

    const result = await triggerDupeCheck(checkRecord)
    if (!result.isSuccess || result.data.length === 0) return false

    const firstMatch = result.data[0]
    dispatch(updateDuplicateInfo({ ...dupeRecord, canAccess: firstMatch.canAccess }))

    const routeId = options?.routeId !== undefined ? options.routeId : null
    nav(generatePath(AppRoutes.DUPE_ACTION, { id: routeId }))
    return true
  }

  return { checkAndHandleDuplicate }
}
